export default "__VITE_ASSET__Dhk1aXqo__"